import { useMemo } from "react";
import { bool, number, object } from "prop-types";
import { BreakdownTableDepths, BreakdownColumns } from "@repo/utils";
import { PinnableCell, AddChildTask, SummaryRow, PlaceholderCell } from "@tools";
import classnames from "classnames";

export const BreakdownNewChildRow = ({
  element,
  tableDepth,
  actualDepthLevel,
  isFirst,
}) => {
  
  const paddingLeft = useMemo(() => (
    `var(--create-padding-${tableDepth})`
  ), [tableDepth]);
  
  const isSection = useMemo(() => (
    tableDepth === BreakdownTableDepths.SECTION
  ), [tableDepth]);
  
  return (
    <SummaryRow
      tableDepth={tableDepth}
      isLastGroupRow={tableDepth === BreakdownTableDepths.MODULE}
      className={classnames(isSection && "summary")}
    >
      <PinnableCell
        colName={ BreakdownColumns.TITLE }
        allowOverflowDisplay={ !isSection }
        pinnedLeft
        resizeable
        tableDepth={isSection ? - 1: tableDepth}
        className="max-w-initial"
        innerStyle={{ paddingLeft }}
      >
        <AddChildTask
          parent={element}
          tableDepth={actualDepthLevel + 1}
          showId={isFirst}
          className={classnames(isSection && "-ml")}
        />
      </PinnableCell>
      <PlaceholderCell tableDepth={tableDepth} />
    </SummaryRow>
  )
};

BreakdownNewChildRow.propTypes = {
  element: object,
  tableDepth: number,
  actualDepthLevel: number,
  isFirst: bool,
}